<template>
  <el-dialog width="420px" class="dialogClass" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="createEnterpriseVisible">
    <div class="details">
      <div class="dialogTilte">创建企业</div>
      <el-form size=""   ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="110px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-form-item label="企业名称" prop="name">
          <el-input type="text" v-model="currencyForm.name" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="所属行业" prop="name">
          <el-select v-model="currencyForm.name" placeholder="请选择所属行业">
            <el-option v-for="item in industryList" :value="item" :label="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人数规模" prop="name">

          <el-select v-model="currencyForm.name" placeholder="请选择人数规模">
            <el-option v-for="item in peopleNumberList" :value="item" :label="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业所有人" prop="name">
          <el-input type="text" v-model="currencyForm.name" placeholder="请输入企业所有人"></el-input>
        </el-form-item>

        <el-form-item label="点击上传" prop="name">
          <div class="upload_img_wrap"  >
            <div v-if="!currencyForm.fileUrl">
              <i class="el-icon-upload"></i>
              <div>点击上传</div>
            </div>
            <div class="upload_box">
              <input @change="handleChangeUpload" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
              <img v-if="currencyForm.fileUrl"  :src="currencyForm.fileUrl" alt="">
              <i @click="handleClickDel" v-if="currencyForm.fileUrl" class="el-icon-delete"></i>
            </div>
          </div>
        </el-form-item>

      </el-form>
    </div>
    <div slot="footer">
      <el-button size="" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交审核</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import { uploadImg ,getOSSData} from '@/utils/uploadOss'
import {mapState} from "vuex";
import {industryList} from '@/mixins'
export default {
  name: 'create_enterprise',
  props: {
    createEnterpriseVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        name:'',
        fileUrl:'',
      },
      currencyFormRules:{
        name:[{ required: true, message: '请输入企业名称', trigger: 'blur'}],
      },

      peopleNumberList:[
        '0-19⼈',
        '20-99⼈',
        '100-499⼈',
        '500-999⼈',
        '1000⼈以上',
      ]
  }
  },
  mixins: [industryList],
  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  mounted() {

  },
  methods: {
    // 上传
    handleChangeUpload(event){
      var file = event.target.files[0];
      uploadImg(file).then(res => {
        console.log(res);
        this.currencyForm.fileUrl =  res.file_path
        this.loading = false
        this.$message.success('上传成功')
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除
    handleClickDel(){
      this.currencyForm.fileUrl = ''
    },

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          // let postDataInfo = {
          //   file:this.currencyForm.file
          // }
          // this.BtnDisabled = true
          // clipUpload(postDataInfo).then(res => {
          //   if (res.code === 0) {
          //     this.$message({
          //       message: '新增成功',
          //       type: 'success',
          //       duration: 1000,
          //       onClose: () => {
          //         this.BtnDisabled = false
          //         this.$emit('success')
          //         this.$emit('update:createEnterpriseVisible', false)
          //       }
          //     })
          //   }else{
          //     this.BtnDisabled = false
          //   }
          // }).catch((e) => {
          //   this.BtnDisabled = false
          // })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:createEnterpriseVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}


.upload_img_wrap {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all .3s;
}
.upload_img_wrap:hover {
  color:#409EFF;
  border-color: #409EFF;
}
.upload_img_wrap:hover .el-icon-upload {
  color: #409EFF;
}
.upload_img_wrap .el-icon-upload {
  font-size: 40px;
  color: #c0c4cc;
  margin: 35px 0 10px;
  transition: all .3s;
}
.upload_box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  line-height: 150px;
}
.upload_box img {
  height: 90%;
  width: 90%;
  margin: 5%;
  z-index: 55;
  box-sizing: border-box;
  display: block;
  object-fit: cover;
}

.upload_box .el-icon-delete {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 20px;
  border: 1px solid #c2c2c2;
  border-radius: 50%;
  z-index: 300;
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
}
.upload_box input {
  width: 100%;
  display: block;
  height: 100%;
  z-index: 20;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
